module.exports = __webpack_public_path__ + "static/bills-6cbb4d0208b5a3d0734ce28d4319a5e6.svg";